module.exports = __webpack_public_path__ + "img/143.6.055c8d64.png";